// eslint-disable-next-line no-restricted-imports
import { OrderCommonOrderTypeEnum } from '@eih-netbroker/api-order';

export const OrderType = OrderCommonOrderTypeEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type OrderType = (typeof OrderType)[keyof typeof OrderType];
